import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {saveBlob} from '../utils/save-blob';

export interface BlobDownloadService {
    saveBlob(url: string, fileName: string): Promise<void>;
}

@Injectable({
    providedIn: 'root'
})
export class BlobDownloadServiceImpl implements BlobDownloadService {
    protected http = inject(HttpClient);


    async saveBlob(url: string, fileName: string): Promise<void> {
        const blob = await this.http.get(url, {responseType: 'blob'}).toPromise();

        saveBlob(blob, fileName);
    }
}
